import PropTypes from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'

function GuestRoute ({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        !localStorage.getItem('@loyalty:token')
          ? (<Component {...props} />)
          : (<Redirect to="/" />)
      }
    />
  )
}

GuestRoute.propTypes = {
  component: PropTypes.elementType.isRequired
}

export default withRouter(GuestRoute)
